module.exports = __webpack_public_path__ + "assets/img/play.c4829aae.svg";